<template>
    <CFooter>
      <div>
        <span>システムに関するお問い合わせ・要望などは
          <b>
            <CLink 
              href="https://app.slack.com/client/T0BR4U4RL/C05A7FVGV0E"
              target="_blank" 
              rel="noopener noreferrer"
              >
              Slack専用チャンネル(#preika_bug_report)
            </CLink>
          </b>
          にてお願いします。</span>
      </div>
      <div
      style="position: relative;"
      >
        <span>&copy; AKI Inc. All Rights Reserved.</span>
      </div>
    </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
